import { CSSObject } from '@chakra-ui/react';

const baseFontFamily = 'accent';
const baseFontWeight = 'medium';
const baseTextColor = 'white';

export const GreenIDText: CSSObject = {
  color: 'white',
  mt: '2',
};

export const GreenIDContainer: CSSObject = {
  bg: 'alpha.500',
  '#greenid-intro-content #greenid-intro-words .lead': {
    fontFamily: 'accent',
    fontStyle: 'normal',
    fontWeight: 'medium',
    fontSize: 'xs',
    color: 'white',
    px: '10',
  },

  '#greenid-container .btn-primary': {
    fontSize: 'xs',
    fontFamily: 'heading',
    bgGradient: 'linear(to-b, gamma.500, gamma.600)',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.15)',
    borderRadius: 'base',
    textColor: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    width: 'auto',
    border: 'none',

    '&:focus': {
      backgroundColor: 'gamma.600',
    },
  },

  '#greenid-source-content': {
    border: 'none !important',
    bg: 'alpha.500',
    px: '10',
    minH: '429px',
  },

  '#greenid-source-content #greenid-source-body': {
    maxW: '472px',
  },

  '#greenid-source-body .dd-container label': {
    color: '#58585b !important',
    fontWeight: 'normal',
  },

  '#greenid-source-body #greenid-u': {
    maxW: '429px',
    p: {
      color: 'white',
    },
  },

  '#greenid-source-header .greenid-modal': {
    position: 'absolute !important',
  },

  '#greenid-container #greenid-source-content #greenid-medicaredvs-multiline-name-toggle':
    {
      color: 'white',
    },

  // Source title styles
  '#greenid-source-content #greenid-source-header #greenid-source-title #greenid-source-title-heading':
    {
      fontFamily: baseFontFamily,
      fontWeight: `${baseFontWeight} !important`,
      color: baseTextColor,
    },

  // Form label styles
  '#greenid-source-body .row .form-group .control-label': {
    fontFamily: baseFontFamily,
    fontWeight: baseFontWeight,
    color: baseTextColor,
  },

  '#greenid-source-body .row .form-group label:not(.dd-option-text):not(.dd-selected-text)':
    {
      fontFamily: baseFontFamily,
      fontWeight: baseFontWeight,
      color: baseTextColor,
    },

  // Help icon styles
  '#greenid-source-body #greenid-FieldsForm .help-block': {
    fontFamily: baseFontFamily,
    fontWeight: baseFontWeight,
    color: baseTextColor,
  },

  '#greenid-source-body .dd-container .dd-select .dd-selected-text': {
    color: '#58585b',
  },

  '#greenid-source-content #greenid-source-header #greenid-source-title .greenid-modal-launch':
    {
      px: 0,
    },

  '#greenid-FieldsForm .control-label, #greenid-FieldsForm .greenid-helpicon, #greenid-source-title #greenid-source-title-heading, #greenid-source-title .greenid-modal-launch, #greenid-source-body .control-label':
    {
      color: 'white',
    },
};
